import {
    karateOrg,
    ryukyuKobujutsuHozonShinkoKaiOrg,
} from 'react-common-eks/dist/data/organizations'

const ryukyuOrganizations = [ryukyuKobujutsuHozonShinkoKaiOrg, karateOrg]

export default ryukyuOrganizations
